import React, { useEffect, useState, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { CFooter, CNav, CNavItem, CNavLink } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import {
  cilHome,
  cilList,
  cilShieldAlt,
  cilMap,
  cilPhone,
  cilPen,
  cilInfo,
  cilLocationPin,
  cilSearch,
} from '@coreui/icons'

const AppFooterUser_pwan = (param) => {
  const [activeKey, setActiveKey] = useState(3)

  const linkText_01 = '상품검색'
  const linkText_02 = '즐겨찾기'
  const linkText_03 = 'HOME'
  const linkText_04 = '주문내역'
  const linkText_05 = '고객센터'

  const link_01 = '/commonMenu/MenuUser_01'
  const link_02 = '/commonMenu/MenuUser_02'
  const link_03 = '/commonMenu/MenuUser_03'
  const link_04 = '/commonMenu/MenuUser_04'
  const link_05 = '/commonMenu/MenuUser_05'

  const linkUrl_01 = '#' + link_01
  const linkUrl_02 = '#' + link_02
  const linkUrl_03 = '#' + link_03
  const linkUrl_04 = '#' + link_04
  const linkUrl_05 = '#' + link_05

  const linkIcon_01 = cilSearch
  const linkIcon_02 = cilLocationPin
  const linkIcon_03 = cilHome
  const linkIcon_04 = cilPen
  const linkIcon_05 = cilPhone

  const navigate = useNavigate()
  useEffect(() => {
    // 페이지 전환 후에 실행될 로직
    const handlePageChange = () => {
      // console.log('Page changed:', window.location.href)

      const href = window.location.href
      if (href.includes(link_01)) {
        setActiveKey(1)
      } else if (href.includes(link_02)) {
        setActiveKey(2)
      } else if (href.includes(link_03)) {
        setActiveKey(3)
      } else if (href.includes(link_04)) {
        setActiveKey(4)
      } else if (href.includes(link_05)) {
        setActiveKey(5)
      }
    }

    // 페이지 전환이 완료된 후에 handlePageChange 실행
    handlePageChange()
  }, [navigate]) // navigate가 변경될 때마다 useEffect 실행

  return (
    <></>
    // <CFooter position="sticky" className="footer-user-fix">
    //   <CNav variant="pills" layout="justified">
    //     <CNavItem>
    //       <CNavLink href={linkUrl_01} active={activeKey === 1} onClick={() => setActiveKey(1)}>
    //         <CIcon color="secondary" icon={linkIcon_01} className="" />
    //         <br></br>
    //         {linkText_01}
    //       </CNavLink>
    //     </CNavItem>
    //     <CNavItem>
    //       <CNavLink href={linkUrl_02} active={activeKey === 2} onClick={() => setActiveKey(2)}>
    //         <CIcon color="secondary" icon={linkIcon_02} className="" />
    //         <br></br>
    //         {linkText_02}
    //       </CNavLink>
    //     </CNavItem>
    //     <CNavItem>
    //       <CNavLink href={linkUrl_03} active={activeKey === 3} onClick={() => setActiveKey(3)}>
    //         <CIcon color="secondary" icon={linkIcon_03} className="" />
    //         <br></br>
    //         {linkText_03}
    //       </CNavLink>
    //     </CNavItem>
    //     <CNavItem>
    //       <CNavLink href={linkUrl_04} active={activeKey === 4} onClick={() => setActiveKey(4)}>
    //         <CIcon color="secondary" icon={linkIcon_04} className="" />
    //         <br></br>
    //         {linkText_04}
    //       </CNavLink>
    //     </CNavItem>
    //     <CNavItem>
    //       <CNavLink href={linkUrl_05} active={activeKey === 5} onClick={() => setActiveKey(5)}>
    //         <CIcon color="secondary" icon={linkIcon_05} className="" />
    //         <br></br>
    //         {linkText_05}
    //       </CNavLink>
    //     </CNavItem>
    //   </CNav>
    // </CFooter>
  )
}

export default React.memo(AppFooterUser_pwan)
